import React, { useState } from "react";
import {
  Box,
  CssBaseline,
  Grid,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import Topbar from "../../../components/topbar/TopBar";
import CatergoryCard from "../components/CatergoryCard";

const USERS = [
  { value: 1, label: "NACIONALES" },
  { value: 2, label: "EXTRANJEROS" },
];

const PriceEnginePanelPage = () => {
  const [selectedUser, setSelectedUser] = useState(1);

  return (
    <>
      <CssBaseline />
      <main className="container">
        <Topbar />
        <Box
          sx={{
            minHeight: "100vh",
            color: "#000",
            "& .MuiTypography-root": { color: "#000" },
            p: 1,
          }}
        >
          <Stack spacing={3}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: 3,
                overflow: "hidden",
                border: "1px solid rgba(16, 24, 40, 0.08)",
              }}
            >
              <Box
                sx={{
                  px: { xs: 2, md: 3 },
                  py: { xs: 2.5, md: 3 },
                  background:
                    "linear-gradient(135deg, #0f3d3e 0%, #165c53 55%, #2d8b74 100%)",
                  color: "#fff",
                }}
              >
                <Stack
                  direction={{ xs: "column", md: "row" }}
                  justifyContent="space-between"
                  alignItems={{ xs: "flex-start", md: "center" }}
                  spacing={2}
                >
                  <Box>
                    <Typography
                      variant="h4"
                      fontWeight={800}
                      sx={{ color: "#fff !important" }}
                    >
                      CLIENTES
                    </Typography>
                  </Box>
                </Stack>
              </Box>
              <Box sx={{ px: { xs: 1, md: 2 }, pt: 1, bgcolor: "#fff" }}>
                <Tabs
                  value={selectedUser}
                  onChange={(event, value) => setSelectedUser(value)}
                  centered
                  sx={{
                    "& .MuiTab-root": {
                      minHeight: 54,
                      textTransform: "none",
                      fontSize: "0.98rem",
                      fontWeight: 700,
                      color: "#000",
                    },
                    "& .MuiTab-root.Mui-selected": {
                      color: "#000",
                      fontWeight: 800,
                      fontSize: "1.105rem",
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#000",
                    },
                  }}
                >
                  {USERS.map((day) => (
                    <Tab key={day.value} value={day.value} label={day.label} />
                  ))}
                </Tabs>
              </Box>
            </Paper>
            <Paper
              elevation={0}
              sx={{
                borderRadius: 3,
                border: "1px solid rgba(16, 24, 40, 0.08)",
                overflow: "hidden",
                bgcolor: "#fff",
                padding: 2,
              }}
            >
              <Box sx={{ px: { xs: 2, md: 3 }, py: 2 }}>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  alignItems={{ xs: "flex-start", sm: "center" }}
                  justifyContent="space-between"
                  spacing={1.5}
                >
                  <Grid container spacing={2} sx={{ rowGap: 3 }}>
                    <Grid item xs={12} sm={3} md={2} marginBottom={1}>
                      <CatergoryCard
                        title={"Precios Base"}
                        url={`/admin/precio-base?nationality=${selectedUser}`}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={2} marginBottom={1}>
                      <CatergoryCard
                        title={"Horarios"}
                        url={"/admin/precio-horario/lista"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={2} marginBottom={1}>
                      <CatergoryCard
                        title={"Feriados"}
                        url={"/admin/precio-feriado/lista"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={2} marginBottom={1}>
                      <CatergoryCard
                        title={"Zona Especial"}
                        url={"/admin/zona-especial/lista"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={2} marginBottom={1}>
                      <CatergoryCard
                        title={"Vehiculos"}
                        url={"/admin/precio-vehiculo/lista"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={2} marginBottom={1}>
                      <CatergoryCard title={"PAIS"} url={"/admin/geography"} />
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
            </Paper>
          </Stack>
        </Box>
      </main>
    </>
  );
};

export default PriceEnginePanelPage;
